'use client'

import { Skeleton } from '@/components/v2/ui/skeleton'

const CONTAINER = 'mx-auto w-full max-w-screen-2xl px-4 md:px-12'
const NAV_ITEMS = 4
const STAT_TILES = 4
const CERTIFICATION_CARDS = 3
const CONTROL_CARDS = 8
const LIST_ROWS = 5

const range = (count: number) => Array.from({ length: count }, (_, index) => index)

function HeaderSkeleton() {
  return (
    <div className="border-b border-trust-center-border">
      <div className={`${CONTAINER} flex h-20 items-center gap-5`}>
        <Skeleton className="h-11 w-24" />
        <Skeleton className="h-3 w-24" />
        <span className="flex-1" />
        <div className="hidden gap-6 md:flex">
          {range(NAV_ITEMS).map((index) => (
            <Skeleton key={index} className="h-4 w-20" />
          ))}
        </div>
        <Skeleton className="h-9 w-36" />
      </div>
    </div>
  )
}

function HeroSkeleton() {
  return (
    <div className="bg-trust-center bg-[url(/trust-center/hero-background.png)] bg-cover bg-center">
      <div className={`${CONTAINER} flex flex-col gap-10 py-11 lg:flex-row lg:items-center lg:justify-between`}>
        <div className="flex w-full max-w-2xl flex-col gap-4">
          <Skeleton className="h-10 w-96 max-w-full bg-white/10" />
          <Skeleton className="h-4 w-full bg-white/10" />
          <Skeleton className="h-4 w-3/4 bg-white/10" />
        </div>
        <div className="flex shrink-0 flex-col gap-3">
          <div className="grid grid-cols-2 gap-px overflow-hidden rounded-md border border-white/15 bg-white/15">
            {range(STAT_TILES).map((index) => (
              <div key={index} className="flex min-w-48 flex-col gap-2 bg-trust-center-deep px-6 py-5">
                <Skeleton className="h-8 w-14 bg-white/10" />
                <Skeleton className="h-3 w-28 bg-white/10" />
              </div>
            ))}
          </div>
          <Skeleton className="h-3 w-80 max-w-full bg-white/10" />
        </div>
      </div>
    </div>
  )
}

function CardGridSkeleton({ count, className }: { count: number; className: string }) {
  return (
    <div className="flex flex-col gap-3.5 py-8">
      <Skeleton className="h-6 w-56" />
      <div className={`grid gap-4 ${className}`}>
        {range(count).map((index) => (
          <Skeleton key={index} className="h-16 rounded" />
        ))}
      </div>
    </div>
  )
}

function ListSkeleton() {
  return (
    <div className="flex flex-col gap-3.5">
      <Skeleton className="h-6 w-40" />
      <div className="flex flex-col gap-2">
        {range(LIST_ROWS).map((index) => (
          <Skeleton key={index} className="h-12 rounded" />
        ))}
      </div>
    </div>
  )
}

export default function LoadingPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <HeaderSkeleton />
      <HeroSkeleton />
      <div className={`${CONTAINER} flex flex-col divide-y divide-trust-center-border`}>
        <CardGridSkeleton count={CERTIFICATION_CARDS} className="md:grid-cols-3" />
        <CardGridSkeleton count={CONTROL_CARDS} className="sm:grid-cols-2 lg:grid-cols-4" />
        <div className="grid gap-10 py-8 lg:grid-cols-2">
          <ListSkeleton />
          <ListSkeleton />
        </div>
      </div>
    </div>
  )
}
